import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageDesignerComponent } from './page-designer.component';
import { SupportingDocumentRuleConfigComponent } from './supporting-document-rule-config/supporting-document-rule-config.component';


const routes: Routes = [
  {
    path: '',
    component: PageDesignerComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: 'supporting-document-rules',
        component: SupportingDocumentRuleConfigComponent,
      },
      {
        path: '',
        loadChildren: () => import('@pics-core/page-builder').then(m => m.CardiPageBuilderModule),
      },
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageDesignerRoutingModule { }
